var defaultStyles = {
  "field": "Base-Field--Field",
  "control": "Base-Field--Control",
  "label": "Base-Field--Label",
  "label_symbol": "Base-Field--LabelSymbol"
};

export { defaultStyles as default };
